import type { RootState } from "Data/Store/Store";
import { useDispatch, useSelector } from "react-redux";
import { useCallback } from "react";

import { loadUserDeliveryAddressesAction } from "./LoadUserDeliveryAddressesAction";
import { clearDeliveryAddressesAction } from "./ClearDeliveryAddressesAction";

const deliveryAddressesSelector = (state: RootState) =>
  state.deliveryAddressesReducer;

export const DeliveryAddressesStoreImplementation = () => {
  const dispatch = useDispatch();
  const deliveryAddressesState = useSelector(deliveryAddressesSelector);

  const loadAddresses = useCallback(
    (args: { token: string; onAuthError:(msg: string) => void ; onForbidden: (msg: string) => void }) =>
      loadUserDeliveryAddressesAction(args)(dispatch),
    [dispatch]
  );

  const clearAddresses = useCallback(
    () => clearDeliveryAddressesAction()(dispatch),
    [dispatch]
  );

  return {
    deliveryAddressesState,
    loadAddresses,
    clearAddresses,
  };
};
